module.exports = __webpack_public_path__ + "static/media/Illus-LoyaltyHarvest@3x.61b499b3.png";